import {AVAILABLE_REACTION_LIST} from '../../modules/comments/reactions/constants';
import {store} from '../utils/shared/store';

const articleReactionsStore = store({
  reactions: {
    all: {},
    user: {}
  }
});

const articleReactionMemoryRepository = {
  subscribe: articleReactionsStore.subscribe,
  getAllReactions () {
    return articleReactionsStore.reactions;
  },
  async setCommonReactions (articleId, reactions) {
    const currentReactions = {...articleReactionsStore.reactions.all?.[articleId]};
    const userReaction = articleReactionsStore.reactions.user?.[articleId];

    if (reactions?.length) {
      reactions.forEach(reaction => {
        if (userReaction && reaction.type === userReaction && reaction.count === 0) {
          currentReactions[reaction.type] = {count: reaction.count + 1};
        } else {
          currentReactions[reaction.type] = {count: reaction.count};
        }
      });
    }

    articleReactionsStore.reactions = {
      ...articleReactionsStore.reactions,
      all: {
        ...articleReactionsStore.reactions.all,
        [articleId]: currentReactions
      }
    };
  },
  initAllReactions (articleId) {
    articleReactionsStore.reactions = {
      ...articleReactionsStore.reactions,
      all: {
        ...articleReactionsStore.reactions.all,
        [articleId]: {...AVAILABLE_REACTION_LIST.reduce((acc, reaction) => {
          acc[reaction] = {count: 0};
          return acc;
        }, {})}
      },
      user: {
        ...articleReactionsStore.reactions.user,
        [articleId]: ''
      }
    };
  },
  async setUserReaction (articleId, reactionType) {
    if (!reactionType) {
      return;
    }

    let countOfCurrentReaction = articleReactionsStore.reactions.all?.[articleId]?.[reactionType]?.count;

    if (!countOfCurrentReaction) {
      countOfCurrentReaction = 1;
    }

    articleReactionsStore.reactions = {
      ...articleReactionsStore.reactions,
      user: {
        ...articleReactionsStore.reactions.user,
        [articleId]: reactionType
      },
      all: {
        ...articleReactionsStore.reactions.all,
        [articleId]: {
          ...articleReactionsStore.reactions.all?.[articleId],
          [reactionType]: {count: countOfCurrentReaction}
        }
      }
    };
  },
  deleteUserReaction (articleId) {
    const currentUserReaction = articleReactionsStore.reactions.user?.[articleId];
    const newCountOfReactions = articleReactionsStore.reactions.all?.[articleId]?.[currentUserReaction]?.count;

    articleReactionsStore.reactions = {
      ...articleReactionsStore.reactions,
      user: {
        [articleId]: ''
      },
      all: {
        ...articleReactionsStore.reactions.all,
        [articleId]: {
          ...articleReactionsStore.reactions.all?.[articleId],
          [currentUserReaction]: {count: newCountOfReactions - 1}
        }
      }
    };
  },
  addReaction (articleId, reactionType) {
    const currentReaction = articleReactionsStore.reactions.user?.[articleId];

    let currentCountOfCurrentReaction = currentReaction
      ? articleReactionsStore.reactions.all[articleId]?.[currentReaction].count
      : 0;
    const newCountOfReactions = articleReactionsStore.reactions.all?.[articleId]?.[reactionType]?.count;

    if (currentReaction) {
      currentCountOfCurrentReaction = currentCountOfCurrentReaction - 1;
    }

    articleReactionsStore.reactions = {
      ...articleReactionsStore.reactions,
      all: {
        ...articleReactionsStore.reactions.all,
        [articleId]: {
          ...articleReactionsStore.reactions.all?.[articleId],
          [reactionType]: {
            count: newCountOfReactions + 1
          },
          [currentReaction]: {
            count: currentCountOfCurrentReaction
          }
        }
      }
    };
  }
};

export {articleReactionMemoryRepository};
